import React from 'react';
import TabPanel from '@mui/lab/TabPanel';
import { ArcTabPanelProps } from './types';

const ArcTabPanel: React.FC<ArcTabPanelProps> = (props) => {
  return <TabPanel {...props} />;
};

export default ArcTabPanel;